import { OperationsBoard } from './OperationsBoard';

export function DashboardPage() {
  return <OperationsBoard />;
}
